import { useQuery } from '@tanstack/react-query';

import { getDashboard, type DashboardParams } from './dashboard.api';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  detail: (params: DashboardParams) => [...dashboardKeys.all, params] as const,
};

/** One query: the Admin API answers the whole dashboard in one call. */
export function useDashboard(params: DashboardParams) {
  return useQuery({
    queryKey: dashboardKeys.detail(params),
    queryFn: ({ signal }) => getDashboard(params, signal),
    staleTime: 60_000,
    placeholderData: (previous) => previous,
  });
}
